import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getFoldingTypes({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_FOLDING_TYPES_REQUEST')

        return axios
            .get(`/foldings/folding-types${paginate}${query}`)
            .then(response => {
                commit('GET_FOLDING_TYPES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_FOLDING_TYPES_FAILURE')
                handleApiError(error, 'Pobranie rodzajów składania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getImpositionTaskFoldingTypes({ commit }, {
        query = ''
    } = {}) {
        commit('GET_IMPOSITION_TASK_FOLDING_TYPES_REQUEST')

        return axios
            .get(`jobs/imposition-task-folding-types${query}`)
            .then(response => {
                commit('GET_IMPOSITION_TASK_FOLDING_TYPES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_IMPOSITION_TASK_FOLDING_TYPES_FAILURE')
                handleApiError(error, 'Pobranie rodzajów składania dla zadania nie powiodło się.')

                return Promise.reject(error)
            })
    }
}